module.exports = __webpack_public_path__ + "img/i can cut pretty much anything.5e849f84.png";